(() => {
  if (window.__kotPremiumVariantSyncLoaded) return;
  window.__kotPremiumVariantSyncLoaded = true;

  const parseVariants = (variantSelects) => {
    const json = variantSelects?.querySelector('[data-kotx-product-variants]');
    if (!json) return [];

    try {
      return JSON.parse(json.textContent || '[]');
    } catch (error) {
      console.error('[KOT Premium] Unable to parse product variants.', error);
      return [];
    }
  };

  const getSelectedOptions = (variantSelects) => {
    if (!variantSelects) return [];

    return Array.from(variantSelects.children)
      .filter((element) => element.matches('.product-form__input, fieldset.product-form__input'))
      .map((optionGroup) => {
        const select = optionGroup.querySelector('select');
        if (select) return select.value;

        const checkedRadio = optionGroup.querySelector('input[type="radio"]:checked');
        return checkedRadio ? checkedRadio.value : null;
      })
      .filter((value) => value !== null);
  };

  const findSelectedVariant = (productRoot) => {
    const variantSelects = productRoot?.querySelector('variant-selects');
    if (!variantSelects) return null;

    const selectedOptions = getSelectedOptions(variantSelects);
    const variants = parseVariants(variantSelects);

    if (!selectedOptions.length || !variants.length) return null;

    return (
      variants.find(
        (variant) =>
          Array.isArray(variant.options) &&
          variant.options.length === selectedOptions.length &&
          variant.options.every((option, index) => option === selectedOptions[index])
      ) || null
    );
  };

const syncSelectedVariant = (productRoot) => {
    if (!productRoot) return null;

    // Handle single-variant products (no variant-selects rendered)
    const variantSelects = productRoot?.querySelector('variant-selects');
    let variant = null;

    if (!variantSelects) {
      // Single variant — read directly from the form's hidden input
      const purchaseFormFallback =
        productRoot.querySelector('.kotx-purchase-form form[data-type="add-to-cart-form"]') ||
        productRoot.querySelector('.kotx-purchase-form form');
      const variantInputFallback = purchaseFormFallback?.querySelector('input[name="id"]');
      if (variantInputFallback?.value) {
        const addButton = purchaseFormFallback.querySelector('[name="add"]');
        const expressButton = purchaseFormFallback.querySelector('[data-kotx-express-checkout]');
        if (addButton) addButton.disabled = false;
        if (expressButton) expressButton.disabled = false;
      }
      return null;
    }

    variant = findSelectedVariant(productRoot);

    const purchaseForm =
      productRoot.querySelector('.kotx-purchase-form form[data-type="add-to-cart-form"]') ||
      productRoot.querySelector('.kotx-purchase-form form');

    if (!purchaseForm) return variant;

    const variantInput = purchaseForm.querySelector('input[name="id"]');
    const addButton = purchaseForm.querySelector('[name="add"]');
    const expressButton = purchaseForm.querySelector('[data-kotx-express-checkout]');

    if (!variant) {
      if (variantInput) {
        variantInput.value = '';
        variantInput.disabled = true;
      }
      if (addButton) addButton.disabled = true;
      if (expressButton) expressButton.disabled = true;
      return null;
    }

    if (variantInput) {
      variantInput.disabled = false;
      variantInput.value = String(variant.id);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const unavailable = variant.available === false;
    if (addButton) addButton.disabled = unavailable;
    if (expressButton) expressButton.disabled = unavailable;

    purchaseForm.dataset.selectedVariantId = String(variant.id);
    return variant;
  };

  window.KotPremiumSyncSelectedVariant = syncSelectedVariant;

  document.addEventListener('change', (event) => {
    const variantControl = event.target.closest(
      '.kotx-pdp variant-selects select, .kotx-pdp variant-selects input[type="radio"]'
    );
    if (!variantControl) return;

    syncSelectedVariant(variantControl.closest('.kotx-pdp'));
  });

  document.addEventListener(
    'submit',
    (event) => {
      const purchaseForm = event.target.closest(
        '.kotx-pdp .kotx-purchase-form form[data-type="add-to-cart-form"]'
      );
      if (!purchaseForm) return;

      syncSelectedVariant(purchaseForm.closest('.kotx-pdp'));
    },
    true
  );

  const syncAllProducts = (scope = document) => {
    scope.querySelectorAll('.kotx-pdp').forEach(syncSelectedVariant);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncAllProducts();
      setTimeout(() => syncAllProducts(), 300);
    });
  } else {
    syncAllProducts();
    setTimeout(() => syncAllProducts(), 300);
  }

  document.addEventListener('shopify:section:load', (event) => {
    syncAllProducts(event.target);
    setTimeout(() => syncAllProducts(event.target), 300);
  });
})();

(() => {
  if (window.__kotPremiumV2Loaded) return;
  window.__kotPremiumV2Loaded = true;

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('.kotx-pdp [data-kotx-thumbs] .thumb');
    if (thumb) {
      const gallery = thumb.closest('[data-kotx-gallery]');
      const stageImage = gallery && gallery.querySelector('.stage img');
      if (stageImage && thumb.dataset.kotxFull) {
        gallery.querySelectorAll('.thumb').forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
        stageImage.removeAttribute('srcset');
        stageImage.src = thumb.dataset.kotxFull;
      }
      return;
    }

    const more = event.target.closest('.kotx-pdp [data-kotx-more]');
    if (more) {
      const container = more.parentElement;
      const description = container && container.querySelector('[data-kotx-desc]');
      if (!description) return;
      const isClamped = description.classList.toggle('clamp');
      more.textContent = isClamped ? 'Read more' : 'Show less';
    }
  });
})();

(() => {
  if (window.__kotPremiumExpressCheckoutLoaded) return;
  window.__kotPremiumExpressCheckoutLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.kotx-pdp [data-kotx-express-checkout]');
    if (!button || button.disabled) return;

    const form = button.closest('form');
    if (!form) return;

    window.KotPremiumSyncSelectedVariant?.(form.closest('.kotx-pdp'));

    button.disabled = true;
    button.classList.add('loading');

    try {
      const variantId = form.querySelector('input[name="id"]')?.value;
      const quantity = form.querySelector('input[name="quantity"]')?.value || '1';

      if (!variantId) {
        throw new Error('Please select a product option before checking out.');
      }

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) }]
        })
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Unable to proceed to checkout.');
      }

      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) {
      const wrapper = form.closest('product-form');
      const errorWrapper = wrapper?.querySelector('.product-form__error-message-wrapper');
      const errorMessage = wrapper?.querySelector('.product-form__error-message');
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message;
        errorWrapper.hidden = false;
      }
      button.disabled = false;
      button.classList.remove('loading');
    }
  });
})();